import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../src/assets/logo.png';
import { AuthProvider } from '../../Context/AuthContext';
import useAdmin from '../../hooks/useAdmin';

const HomeHeaderNew = () => {
    const { user } = useContext(AuthProvider)
    const [isAdmin] = useAdmin(user?.email)
    console.log(isAdmin)
    return (
        <div className='bg-blue-900 w-full py-2'>
            <div className='max-w-6xl mx-auto xl:px-0 px-5 flex items-center md:justify-between justify-center'>
                <div className='flex items-center gap-2'>
                    <img src={logo} className='h-7 w-7' alt="" />
                    <div>
                        <h3 className='text-xl font-semibold text-white uppercase'>Make Your Dream True</h3>
                        {/* <p className='text-sm text-gray-400'>easy to learn</p> */}
                    </div>
                </div>
                <div className='hidden md:block'>
                    <div className='flex items-start gap-7'>
                        <div className='flex items-center gap-2 text-xs text-white mt-2'>
                            <p className='cursor-pointer'>Home  |</p>
                            <a href='#blog'>News & Events  |</a>
                            <Link to='/contact'>Contact</Link>
                            {
                                isAdmin ?
                                    <Link to='/dashboard'>| Dashboard</Link>
                                    :
                                    undefined
                            }
                        </div>
                        <div className='flex items-center gap-2'>
                            <div className='flex flex-col justify-right text-right'>
                                <h3 className='text-sky-400 text-xl font-semibold'>+8809696055010</h3>
                                {/* <p className='text-xs text-white'>Admissions department</p> */}
                            </div>
                            <i class="fa-solid fa-square-phone text-3xl font-semibold text-white"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeHeaderNew;